import React from 'react';

/**
 * Hook for handling block settings extraction
 * Consolidates block settings retrieval logic
 */
export const useBlockSettings = (props) => {
    // Add null safety checks for props and props.settings
    if (!props || !props.settings) {
        return {
            blockId: null,
            blockSettings: {},
            hasSettings: false
        };
    }

    const blockId = props.settings.block_id;
    const blockSettings = props.settings.block_settings || {};
    
    return {
        blockId,
        blockSettings,
        hasSettings: Object.keys(blockSettings).length > 0
    };
};

/**
 * Hook for extracting common animation settings
 */
export const useBlockAnimations = (blockSettings) => {
    const enableAnimations = blockSettings.enable_animations || false;
    const animationType = blockSettings.animation_type || 'slide-fade-up';
    const animationDuration = blockSettings.animation_duration || 800;
    const animationDelay = blockSettings.animation_delay || 0;
    const animationTrigger = blockSettings.animation_trigger || 'onscroll';
    
    return {
        enableAnimations,
        animationType,
        animationDuration,
        animationDelay,
        animationTrigger,
        animationProps: {
            enableAnimations,
            animationType,
            animationDuration,
            animationDelay,
            animationTrigger
        }
    };
};

/**
 * Generic wrapper component for common block functionality
 */
export const BlockWrapper = ({ 
    children, 
    blockSettings, 
    animation, 
    positionProps = {}, 
    eventHandlers = {},
    className = '',
    style = {}
}) => {
    const combinedStyle = {
        ...style,
        ...animation?.style,
        ...positionProps
    };
    
    return (
        <div 
            ref={animation?.ref}
            style={combinedStyle}
            className={className}
            onClick={(e) => {
                // console.log('🎯 BlockWrapper click triggered', { eventHandlers });
                eventHandlers.handleClick && eventHandlers.handleClick(e);
            }}
            onMouseEnter={(e) => {
                // console.log('🎯 BlockWrapper mouse enter triggered');
                eventHandlers.handleMouseEnter && eventHandlers.handleMouseEnter(e);
            }}
            onMouseLeave={(e) => {
                // console.log('🎯 BlockWrapper mouse leave triggered');
                eventHandlers.handleMouseLeave && eventHandlers.handleMouseLeave(e);
            }}
            onFocus={eventHandlers.handleFocus}
            onBlur={eventHandlers.handleBlur}
        >
            {children}
        </div>
    );
};
